import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import CompanyForm from "./CompanyForm";

const CreateCompany = () => {
  return (
    <>
      <Helmet>
				<title>Company - Create</title>
			</Helmet>
      <Header />
      <div className="container-fluid maindiv">
        <CompanyForm />
      </div>
    </>
  );
};

export default CreateCompany;
